<template>
    <div id="inner-auth-content" class="d-flex flex-column align-center justify-left" style="width: 350px">
        <v-form class="mt-9" style="width: 300px" ref="form" lazy-validation>
            <div class="d-flex justify-center align-center">
                <v-text-field v-model="form.email" :rules="[rules.required, rules.email]" type="email" label="Email" autocomplete="email" width="300" autofocus required dense class="mb-3 left-input" :class="{ 'autofill-fix': autofillFix }" @keyup.enter="submitForm" data-cy="email"> </v-text-field>
            </div>

            <div class="d-flex justify-start align-center">
                <p v-if="form.errors && form.errors.email && form.errors.email.length" data-cy="email-error" class="red--text subtitle-2 mb-3">
                    {{ tServer(form.errors.email[0]) }}
                </p>
            </div>

            <div class="d-flex justify-center align-center">
                <v-text-field
                    style="height: 52px"
                    v-model="form.password"
                    :rules="[rules.required, rules.validLength]"
                    :type="showPassword ? 'text' : 'password'"
                    :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                    @click:append="showPassword = !showPassword"
                    @keyup.enter="submitForm"
                    :label="$t('auth.password')"
                    autocomplete="current-password"
                    required
                    dense
                    class="mb-3 left-input"
                    :class="{ 'autofill-fix': autofillFix }"
                    data-cy="password"
                    @focus="autofillFix = false"
                ></v-text-field>
            </div>

            <div class="d-flex justify-start align-center">
                <p v-if="form.errors && form.errors.password && form.errors.password.length" class="red--text subtitle-2 mb-0" data-cy="password-error">
                    {{ tServer(form.errors.password[0]) }}
                </p>
            </div>

            <div class="d-flex justify-start align-center" style="margin-top: -10px; height: 32px">
                <p v-if="form.errors && form.errors.message && form.errors.message.length" v-html="tServer(form.errors.message[0])" class="error--text" style="line-height: 16px; font-size: 12px" data-cy="errors"></p>
            </div>

            <div class="d-flex justify-center">
                <v-btn @click="submitForm" :loading="loading" class="mt-0 myprovet-btn-ok" data-cy="submit-button"> {{ $t('auth.login') }} </v-btn>
            </div>
        </v-form>

        <div class="responsive-auth-login-link">
            <span class="d-flex justify-left responsive-auth-font" style="color: darkgrey">
                {{ $t('auth.forgotQuestion') }}

                <inertia-link class="no-underline" href="/forgot-password" data-cy="forgot-password-link"> &nbsp;{{ $t('auth.clickHere') }} </inertia-link>
            </span>

            <!--<span class="d-flex mt-1 justify-left responsive-auth-font" style="color: darkgrey">
                Novo na nossa plataforma?

                <inertia-link class="no-underline" href="/register"> &nbsp;Registe-se aqui </inertia-link>
            </span>-->
        </div>

        <social-media-auth> </social-media-auth>
    </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useUserStore } from '@/Stores/user';
import { axios } from '@/Services/Backend';
import AuthLayout from '../../Layouts/AuthLayout';
import { i18n } from '@/i18n';

export default {
    data() {
        return {
            form: {
                email: '',
                password: '',
                errors: null,
            },
            rules: {
                required: (value) => (value && !!value) || i18n.t('validation.required'),
                validLength: (value) => (value && value.length >= 8) || i18n.t('userDetails.rules.minLength'),
                email: function (value) {
                    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return value && re.test(value) ? true : i18n.t('userDetails.rules.invalidEmail');
                },
            },
            showPassword: false,
            loading: false,
            autofillFix: false,
        };
    },

    created() {
        //console.log('create',this.$inertia);
        this.verifyIP()
    },

    computed: {
        ...mapStores(useUserStore),
    },

    mounted() {
        this.verifyIP()
        this.autoLoginCheckingInterface();
    },

    methods: {
        verifyIP(){
           if(this.$inertia!=null){
                //console.log('verifyIP',this.$inertia.page.props.ip,this.userStore.validIps);
                if(this.$inertia.page.props.ip!==this.userStore.validIps[0]
                    && this.$inertia.page.props.ip!==this.userStore.validIps[1]
                    && !_.startsWith(this.$inertia.page.props.ip,this.userStore.validIps[2])
                ){
                    this.$inertia.visit('/');
                }
           }
        },
        autoLoginCheckingInterface() {
            // each 100ms we check if the issue was produced
            let intervalDetectAutofill = setInterval(() => {
                if (
                    // we target at least one of the stuff that will be affected by autofill
                    // to do our checking
                    document.querySelectorAll('input[type="email"]:-webkit-autofill').length > 0
                ) {
                    // and we inform the system about the issue if it is produced
                    this.autofillFix = true;

                    // we stop to check if issue was produced
                    clearInterval(intervalDetectAutofill);
                }
            }, 100);

            // if after 3s nothing appear, means no autofill was made
            setTimeout(() => {
                if (intervalDetectAutofill) {
                    clearInterval(intervalDetectAutofill);
                    intervalDetectAutofill = null;
                }
            }, 3000);
        },

        submitForm() {
            if (!this.$refs.form.validate()) return;
            this.loading = true;
            this.form.errors = null;

            axios
                .post('/login', this.form)
                .then(() => {
                    this.userStore.login(this.$inertia, this.$tawkMessenger,true);
                    //this.$inertia.visit('/backoffice');
                })
                .catch((error) => {
                    const errors = error.response.data.errors;

                    this.loading = false;
                    this.form.errors = errors;
                });
        }
        //'/login/admin?email='+form.email'passord''
    },

    layout: AuthLayout,
};
</script>

<style scoped>
.no-underline {
    text-decoration: none;
}

@media only screen and (min-width: 1025px) {
    #inner-auth-content {
        max-width: 350px;
    }
}
</style>

<style>
.autofill-fix.v-text-field.v-input--dense .v-label {
    top: 4px;
    left: 0 !important;
    transform: translateY(-18px) scale(0.75);
}
</style>
